import { render, staticRenderFns } from "./lectures.vue?vue&type=template&id=0705eda8&scoped=true&"
import script from "./lectures.vue?vue&type=script&lang=js&"
export * from "./lectures.vue?vue&type=script&lang=js&"
import style0 from "./lectures.vue?vue&type=style&index=0&id=0705eda8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0705eda8",
  null
  
)

export default component.exports